import React, { useEffect } from "react";

const DelphiAudioIframe: React.FC = () => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://www.delphi.ai") return;
      console.log("Received message from Delphi iframe:", event.data);
      if (event.data.isAuthenticated) {
        console.log("User is authenticated");
        // Update UI or logic if needed
      } else if (event.data.error) {
        console.error("Authentication error:", event.data.error);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <iframe
      src="https://www.delphi.ai/fabricegrinda/fabrice-dev"
      style={{
        width: "100%",
        height: "100%",
        border: "none",
        display: "block",
      }}
      title="Delphi Interaction"
      allow="fullscreen; microphone; otp-credentials"
    ></iframe>
  );
};

export default DelphiAudioIframe;
